import React from 'react';
import PropTypes from 'prop-types';
import CSSModules from 'react-css-modules';
import styles from './styles.scss';

const TableHeader = ({ columns, ...rest }) => {
  const columnTotalSizeDenominator = columns.reduce((sum, c) => sum + (c.size || 1), 0);
  return (
    <div styleName="row" {...rest}>
      {columns.map((c, i) => {
        const percentage = `${Math.floor(((c.size || 1) / columnTotalSizeDenominator) * 100)}%`;
        const style = {
          textAlign: c.align || 'center',
          flex: `0 0 ${percentage}`,
          maxWidth: `${percentage}`,
          paddingLeft: 0,
          paddingRigh: 0,
        };
        return (<div key={i} style={style}>{c.label}</div>);
      })}
    </div>
  );
};

TableHeader.propTypes = {
  columns: PropTypes.arrayOf(PropTypes.shape({
    label: PropTypes.node,
    size: PropTypes.number,
  })).isRequired,
};

export default CSSModules(TableHeader, styles, { allowMultiple: true });
